import { Col, Row } from "antd";
import { useBannerMobileContext } from "../../../context/BannerMobileContext/BannerMobileContext";
import { BannerMobileFormData, DefaultImageList } from "../../../context/BannerMobileContext/constants";
import FileUploadComponent, { FileData } from "../../../components/FileUploadComponent";
import { FileUploadItem, BannerMobileFileProps } from "./constants";


const BannerMobileFiles: React.FC<BannerMobileFileProps> = ({ isUpper }) => {
	const { bannerMobileDetail, setBannerMobileForm } = useBannerMobileContext();

	const handleFileChange = (files: FileData[] | null, key: keyof BannerMobileFormData["images"]) => {
		setBannerMobileForm(prevState => ({
			...prevState,
			images: {
				...prevState.images,
				[key]: files && files.length > 0 ? files[0].file : null,
			},
		}));
	};

	return (
		<>
			<Row gutter={20}>
				<Col span={20} key={FileUploadItem.key}>
					<FileUploadComponent
						title={FileUploadItem.label}
						onChange={(fileData: FileData[] | null) => handleFileChange(fileData, FileUploadItem.key as keyof BannerMobileFormData["images"])}
						dimensions={isUpper ? FileUploadItem.dimensions.upper : FileUploadItem.dimensions.lower}
						maxFileSize={FileUploadItem.maxFileSize}
						isRequired={bannerMobileDetail?.isUpper !== isUpper ? true : false}
						allowedExtensions={FileUploadItem.extensions}
						defaultUrl={bannerMobileDetail?.isUpper === isUpper ? bannerMobileDetail?.imageList[FileUploadItem.default as keyof DefaultImageList] as string : undefined}
					/>
				</Col>
			</Row>
		</>
	);
};

export default BannerMobileFiles;
